/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { Component } from '@angular/core';

/**
 * Component for our Aero Image Radio Group.
 */
@Component({
  selector: 'aero-image-radio-group',
  templateUrl: './aero-image-radio-group.component.html',
  standalone: false,
})
export class AeroImageRadioGroupComponent {
  /**
   * The selected Image from the radio group.
   */
  public selectedImage : any;

  constructor() {}
}
